import { useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { exchangeCode } from "../auth/cognito";
import { useAuth } from "../auth/AuthContext";

export function AuthCallback() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { refreshFromStorage } = useAuth();
  const [error, setError] = useState<string>();
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    const code = params.get("code");
    if (!code) {
      setError("Missing authorization code");
      return;
    }
    exchangeCode(code)
      .then(() => {
        refreshFromStorage();
        navigate("/meets", { replace: true });
      })
      .catch((e: Error) => setError(e.message));
  }, [params, navigate, refreshFromStorage]);

  return (
    <div className="card">
      {error ? (
        <>
          <h2 className="error">Sign-in failed</h2>
          <p className="muted">{error}</p>
        </>
      ) : (
        <p>Signing you in…</p>
      )}
    </div>
  );
}
